import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
// import getLocationsColumns from '../../../const/Columns/getLocationsColumns'
// import {
//   deleteLocationsServer,
//   getLocationsServer
// } from '../../../apis/locationsApi'
import { Link } from 'react-router-dom'
import { deleteLocationsServer, getLocationsServer } from '../../../apis/locationApi'
import getLocationsColumns from '../../../const/columns/getLocationsColumn'

const Locations = () => {
  const [locations, setLocations] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchLocations()
  }, [])

  const fetchLocations = async () => {
    try {
      const res = await getLocationsServer()
      setLocations(res.result)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const deleteLocations = async id => {
    const isConfirmed = window.confirm(
      'Are you sure you want to delete this Location?'
    )
    if (isConfirmed) {
      await deleteLocationsServer(id)
      setLoading(true)
      fetchLocations()
    }
  }

  const columns = getLocationsColumns(deleteLocations)
  return (
    <>
      <div className='main-wrapper'>
        <div className='page-wrapper'>
          <div className='content container-fluid'>
            <div className='d-flex  justify-content-between  align-items-center'>
              <Link to='/AddLocations' className='btn add-new btn-primary mb-3'>
                Add Locations
              </Link>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className='table-respoinsive'>
                <Table
                  columns={columns}
                  dataSource={locations?.length > 0 ? locations : []}
                  className='table-striped '
                  rowKey={record => record.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Locations
